import React from 'react';
import '../../App.css';
import PaidMrForm from '../PaidMrForm'

function PaidMrPage({ sessionObject }) {
    // if (!sessionObject.sessionVariables["modules"].includes("PaidMr")) {
    //     return;
    // }
    return (
        <div className="page-challan">
            <PaidMrForm sessionObject={sessionObject} />
        </div>
    );
}

export default PaidMrPage;